import { AbstractControl } from "@angular/forms";
import { digitsFaToEn } from '@persian-tools/persian-tools';

export function rangeValidator(controller: AbstractControl) {
    if (!controller.value) return null;

    let input = digitsFaToEn(`${controller.value}`),
        isFirstLessThanSecond = false;

    // Regex link: https://regex101.com/r/0s9W09/1 by Mehdi Rahimi
    /**
     * Regex will checks if there is just one single input
     * like `4-12` and without anything followed by and in every
     * part of the expression user allowed to use 4 digits and it
     * means user is allowed to use numbers between 1 and 9999.
     * you can modify it by 
     */
    const regex = /([0-9]{1,4}(?=-))-?(?<=[-])([0-9]{1,4})(?![0-9]|[a-z]|\s|\w|\W)/yd;
    const isStructureValid = regex.test(input);

    /**
     * Fist value of range should be smaller that second
     * one we should check this to ensure that this is ok with user.
     */
    if (isStructureValid) {
        const splittedInput = input.split('-');
        const firstNo = splittedInput[0];
        const secondNo = splittedInput[1];
        
        isFirstLessThanSecond = +firstNo < +secondNo; 
    }
    
    return isStructureValid && isFirstLessThanSecond ? null : {
        rangePattern: {
            valid: false
        }
    };
}
